module.exports = __webpack_public_path__ + "fonts/Inter-500-greek53.4a4b49c.woff2";